// extracted by mini-css-extract-plugin
module.exports = {"title":"FeaturePageHeader_title__Shtmw","subtitle":"FeaturePageHeader_subtitle__CNmWs","description":"FeaturePageHeader_description____U8F","cta":"FeaturePageHeader_cta__xXML5"};